import React from 'react';
import HeaderFive from '../../components/Header/HeaderFive';
import FooterThree from '../../components/Footer/FooterThree';
import CareerMain from './careerMain';


const career = () => {
  return (
    <>
      <HeaderFive />
      <CareerMain />
      <FooterThree />
    </>
  );
};

export default career;
